import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

/**
 * Syncs unread notification count to native tab bar badge.
 * Distinct from notification-badge (Action Cable web badge).
 *
 * @example
 *   <span data-controller="bridge--native-notification-badge"
 *         data-bridge-unread-count-value="3"
 *         class="hidden"></span>
 */
export default class extends BridgeComponent {
  static component = "notification_badge"
  static values = { unreadCount: Number }

  connect() {
    super.connect()
    if (!this.enabled) return

    this.send("connect", { count: this.unreadCountValue })
  }

  unreadCountValueChanged() {
    if (!this.enabled) return
    this.send("update", { count: this.unreadCountValue })
  }
}
